// utils/normalizeZone.js
const ALIAS_MAP = {
  // ===== Canada =====
  'Canada/Eastern': 'America/Toronto',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific': 'America/Vancouver',
  'Canada/Newfoundland': 'America/St_Johns',
  'Canada/Atlantic': 'America/Halifax',
  'Canada/Saskatchewan': 'America/Regina',

  // ===== US =====
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',

  // ===== International =====
  'Asia/Istanbul': 'Europe/Istanbul',
  'Turkey': 'Europe/Istanbul',
  'Egypt': 'Africa/Cairo',
  'Iran': 'Asia/Tehran',
  'Israel': 'Asia/Jerusalem',
  'PRC': 'Asia/Shanghai',
  'ROC': 'Asia/Taipei',
  'Singapore': 'Asia/Singapore',
  'GB': 'Europe/London',
  'GB-Eire': 'Europe/London',

  // ===== Mexico =====
  'Mexico/BajaNorte': 'America/Tijuana',
  'Mexico/BajaSur': 'America/Mazatlan',
  'Mexico/General': 'America/Mexico_City',

  // ===== Brazil =====
  'Brazil/East': 'America/Sao_Paulo',
  'Brazil/West': 'America/Manaus',
  'Brazil/DeNoronha': 'America/Noronha',

  // ===== Chile =====
  'Chile/Continental': 'America/Santiago',
  'Chile/EasterIsland': 'Pacific/Easter',

  // ===== NZ =====
  'NZ': 'Pacific/Auckland',
  'NZ-CHAT': 'Pacific/Chatham',

  // ===== UTC/GMT =====
  'UTC': 'Etc/UTC',
  'GMT': 'Etc/GMT',
  'GMT+0': 'Etc/GMT',
  'GMT-0': 'Etc/GMT',

  // ===== Other Legacy =====
  'W-SU': 'Europe/Moscow', // Soviet Union legacy
  'Cuba': 'America/Havana',
  'Jamaica': 'America/Jamaica',
  'Poland': 'Europe/Warsaw',
  'Portugal': 'Europe/Lisbon',
  'Hongkong': 'Asia/Hong_Kong',
  'ROK': 'Asia/Seoul', // South Korea
  'Japan': 'Asia/Tokyo',
  'Kwajalein': 'Pacific/Kwajalein'
};

export default function normalizeZone(zone) {
  if (!zone) return 'Etc/UTC'; // Fallback for undefined/null

  const normalizedZone = ALIAS_MAP[zone] || zone;

  // Optional: Validate against Intl API
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: normalizedZone });
    return normalizedZone;
  } catch {
    return 'Etc/UTC'; // Fallback to UTC if invalid
  }
}